export default {
  VERSION: process.env.VUE_APP_VERSION,
  API_URI: process.env.VUE_APP_API_URI
};
